module.exports = __webpack_public_path__ + "img/vanne.985d837f.png";